module.exports = __webpack_public_path__ + "static/balloon-hunt-3f8571cd01997ae327a2d0e388fffd74.jpg";